import React, { useState, useEffect } from "react";

import { researchInterestDb, researchFundingDb } from "../../../db/dbClasses";
import { BoxDiv } from "../../Miscellaneous/FancyDiv.component";
import NumberedList from "../../Miscellaneous/NumberedList.component";
import Header from "../../Miscellaneous/Header.component";
import SubHeader from "../../Miscellaneous/SubHeader.component";

import CardDeck from "react-bootstrap/CardDeck";

// The inner card renderer component.

const Research = () => {
  const [researchInterests, setResearchInterests] = useState([]);
  const [researchFunding, setResearchFunding] = useState([]);

  const getData = async () => {
    let funding = await researchFundingDb.read();
    let interests = await researchInterestDb.read();
    setResearchFunding(funding);
    setResearchInterests(interests);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="p-0 font-open-sans" style={{ minHeight: "100vh" }}>
      <Header content="Research Interests and Funding" />
      <BoxDiv>
        <div className="w-100 p-5 pt-2">
          <SubHeader id="interests" content="Research Interests" />
          <div className="w-100 mx-auto p-4">
            <CardDeck>
              <NumberedList list={researchInterests} searchKey="title" />
            </CardDeck>
          </div>
          <SubHeader id="funding" content="Research Funding" />
          <div className="w-100 mx-auto p-4">
            <CardDeck>
              <NumberedList list={researchFunding} searchKey="title" />
            </CardDeck>
          </div>
        </div>
      </BoxDiv>
    </div>
  );
};

export default Research;
